import axios from 'axios';
import store from '../../store/index';
import ViewUI from 'view-design';
import qs from 'qs'


// 环境的切换
if (process.env.NODE_ENV == 'development') {
    // axios.defaults.baseURL = 'http://lsh.codecore.cn/yun/';
    axios.defaults.baseURL = 'https://gw.guowuwushu.com/yun/';
} else if (process.env.NODE_ENV == 'debug') {
    // axios.defaults.baseURL = 'http://lsh.codecore.cn/yun/';
    axios.defaults.baseURL = 'https://gw.guowuwushu.com/yun/';
} else if (process.env.NODE_ENV == 'production') {
    // axios.defaults.baseURL = 'http://lsh.codecore.cn/yun/';
    axios.defaults.baseURL = 'https://gw.guowuwushu.com/yun/';
}
// axios.defaults.baseURL = 'http://lsh.codecore.cn/yun/';

// 请求超时时间'
axios.defaults.timeout = 10000;
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 请求拦截器
axios.interceptors.request.use(function (config) {
    // 设置token
    const token = store.state.user.token;
    config.headers["token"] = token;
    // 设置organ-id
    const organ_id = store.state.user.organ_id;
    config.headers["organ-id"] = organ_id;
    // 设置请求栏目
    const menu_id = store.state.app.menu_left_name;
    config.headers["menu-id"] = menu_id;
    return config
}, function (error) {
    return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况    
    error => {
        if (error && error.stack.indexOf('timeout') > -1) {
            ViewUI.Message.error('请求超时')
        } else if (error.response.status) {
            switch (error.response.status) {
                case 400:
                    ViewUI.Message.error('错误请求')
                    break;
                case 403:
                    ViewUI.Message.error('拒绝访问')
                    break;
                case 404:
                    ViewUI.Message.error('请求错误,未找到该资源')
                    break;
                case 405:
                    ViewUI.Message.error('请求方法未允许')
                    break;
                case 500:
                    ViewUI.Message.error('服务器端出错')
                    break;
                case 501:
                    ViewUI.Message.error('网络未实现')
                    break;
                case 502:
                    ViewUI.Message.error('网络错误')
                    break;
                case 503:
                    ViewUI.Message.error('服务不可用')
                    break;
                // 其他错误
                default:
                    ViewUI.Message.error('未知错误：' + error.message)

            }
            return Promise.reject(error.response);
        }
    }
);
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 * @param {Number}} timeout [请求超时 单位ms] 
 */
function get(url, params, timeout = 10000) {
    var data = {
        params: params
    };
    return new Promise((resolve, reject) => {
        axios.get(url, data, { timeout })
            .then(res => {
                if (res.data.code == '200') {
                    resolve(res.data);
                } else {
                    resolve(res.data);
                    ViewUI.Message.error(res.data.msg);
                }
                store.state.app.spinShow = false;
            })
            .catch(err => {
                reject(err.data);
                store.state.app.spinShow = false;
            })
    });
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 * @param {Number}} timeout [请求超时 单位ms] 
 */
function post(url, params, timeout) {

    return new Promise((resolve, reject) => {
        // 过滤掉上传图片参数格式化
        if (url != 'admin/common/upload') {
            params = qs.stringify(params)
        }
        axios.post(url, params, { timeout })
            .then(res => {
                store.state.app.spinShow = false;
                if (res.data.code == '200') {
                    resolve(res.data);
                } else {
                    resolve(res.data);
                    ViewUI.Message.error(res.data.msg);
                }
            })
            .catch(err => {
                reject(err.data);
                store.state.app.spinShow = false;
            })
    });
}

export default {
    post,
    get
}


// WEBPACK FOOTER //
// ./src/assets/js/http.js